import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TeamsService } from 'src/app/_services/teams.service';
import { ModaleProfiloComponent } from '../modale-profilo/modale-profilo.component';
import { ProfileService } from 'src/app/_services/profile.service';
import { UtilityService } from 'src/app/_services/utility.service';
import Modal from 'bootstrap/js/dist/modal';
import { Chart, ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ScrumService } from 'src/app/_services/scrum.service';
// import ng-lottie
import colorLib from '@kurkle/color';
import {
  default as annotation,
  AnnotationOptions
} from 'chartjs-plugin-annotation';
import 'chartjs-adapter-moment';
import { ProjectService } from 'src/app/_services/project.service';
import { Subject, takeUntil, debounceTime, firstValueFrom } from 'rxjs';

/* Charts */
Chart.register(annotation); //registro il plugin di annotation ai grafici
const CHART_COLORS = {
  light_orange: 'rgb(255, 178, 107)',
  blue: 'rgb(0, 51, 124)' /* Necessary */,
  orange: 'rgb(255, 123, 84)',
  light_blue: 'rgb(51, 102, 153)',
  dark_orange: 'rgb(204, 102, 0)',
  light_green: 'rgb(153, 204, 153)',
  purple: 'rgb(68, 50, 102)',
  yellow: 'rgb(255, 205, 86)' /* Necessary */,
  red: 'rgb(193, 49, 0)',
  green: 'rgb(65, 153, 69)' /* Necessary */
};

const PIE_CHART_COLORS = {
  1: '#FF6F61',
  2: '#FF9A00',
  3: '#F2C94C',
  4: '#D16666',
  5: '#56A3BF',
  6: '#3D7AA3',
  7: '#529E66',
  8: '#9A5FB5',
  9: '#6A4B8A',
  10: '#6B728E'
};

@Component({
  selector: 'app-card-lista-teams',
  templateUrl: './card-lista-teams.component.html',
  styleUrls: ['./card-lista-teams.component.css']
})
export class CardListaTeamsComponent implements OnInit, AfterViewInit {
  teams: any;
  readOnly: boolean = false;
  selectedProfileData: any;
  selectedProjectRole: any;
  selected_user_profile: any;
  id: any;
  profile: any;
  teamsProjects?: any;
  teamsCourses?: any;
  aspiration: string;
  myModalAlternative: Modal;
  dataSprint: any;
  startSprintNumber: number | null;
  endSprintNumber: number | null;
  destroy$ = new Subject<void>();
  searchTeamText: string | null = null;
  searchTeamSubject = new Subject<string>();
  teamProjectsSelect: any; // l'array dei progetti della select
  previousSearchValue: string | null = '';
  selectedTeamProjects: any[] = [];

  expansionPanelStates: { [key: number]: boolean } = {}; // Oggetto per tenere traccia dello stato di ogni pannello

  public pieChartLabels: string[] = [
    'Percentuale 1',
    'Percentuale 2',
    'Percentuale 3'
  ];
  public pieChartData: number[] = [30, 40, 30]; // Inserisci qui le tue percentuali
  public pieChartType: string = 'pie';

  percentage = [{ value: 50 }, { value: 60 }];

  public barChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0.4
      }
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {},
      y: {
        min: 10
      }
    },
    plugins: {
      legend: { display: true }
    }
  };

  switchIndex = 0;

  public barChartLabels: string[] = [
    '2006',
    '2007',
    '2008',
    '2009',
    '2010',
    '2011',
    '2012'
  ];
  public barChartType: ChartType = 'bar';

  public barChartData: ChartData<'bar'> = {
    labels: this.barChartLabels,
    datasets: [
      { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
      { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
    ]
  };

  /* GIF */
  public lottieConfig: Object;
  private anim: any;
  private animationSpeed: number = 1;

  typologies: any; //tutte le tipologie team disponibili

  /* GRAFICI */
  @ViewChildren('evolChart') evolCharts: QueryList<ElementRef>;
  evolChartsArray: any;
  @ViewChildren('capChart') capCharts: QueryList<ElementRef>;
  capChartsArray: any;
  @ViewChildren('teamChart') teamCharts: QueryList<ElementRef>;
  teamChartsArray: any;
  labels: any = [];
  media: any;

  showChart = false;

  configTeamChartData: any;

  isDesktop: boolean = true;
  isMobile: boolean = false;
  isTablet: boolean = false;

  constructor(
    public readonly utilityService: UtilityService,
    private readonly route: ActivatedRoute,
    private readonly teamsService: TeamsService,
    private readonly dialog: MatDialog,
    private readonly sanitizer: DomSanitizer,
    private readonly profileService: ProfileService,
    private readonly scrumService: ScrumService,
    private readonly router: Router,
    private readonly projectService: ProjectService
  ) {
    this.lottieConfig = {
      path: 'assets/animations/sadCat.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
    };
  }

  ngOnInit() {
    this.getTeams();
    this.getProjectSelect();

    this.searchTeamSubject.pipe(debounceTime(1000)).subscribe({
      next: value => {
        if (value !== this.previousSearchValue) {
          this.previousSearchValue = value;
          this.getProjectSelect(value);
        }
      }
    });
    // Controlla le dimensioni della finestra quando il componente viene caricato
    const screenWidth = window.innerWidth;
    this.isMobile = false;
    if (screenWidth <= 567) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.isTablet = false;
    if (screenWidth >= 568 && screenWidth <= 992) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }

    if (screenWidth > 992) {
      this.isDesktop = true;
    } else {
      this.isDesktop = false;
    }
  }

  ngAfterViewInit(): void {
    const el = document.querySelector('#exampleModal');
    if (el) {
      this.myModalAlternative = new Modal(el);
    }
  }

  getTeams(year = '', projectIds?: number[]) {
    let utility = this.utilityService;

    this.teamsService
      .getTeams(
        year,
        this.startSprintNumber || '',
        this.endSprintNumber || '',
        projectIds
      )
      .subscribe(res => {
        this.typologies = res.team_categories;
        this.teams = res.result;
        this.teamsProjects = res.result.filter(
          (item: any) => item.is_course !== 1
        );

        this.teamsProjects.forEach((project: any) => {
          project.filestorage.path = utility.getSanitizeUrl(
            project.filestorage.path
          );

          project.project_user.forEach(function (user_pivot: any) {
            user_pivot.user.filestorage.path = utility.getSanitizeUrl(
              user_pivot.user.filestorage.path
            );
          });
        });

        this.teamsCourses = res.result.filter(
          (item: any) => item.is_course !== 0
        );

        this.teamsCourses.forEach(function (course: any) {
          course.filestorage.path = utility.getSanitizeUrl(
            course.filestorage.path
          );

          course.project_user.forEach(function (user_pivot: any) {
            user_pivot.user.filestorage.path = utility.getSanitizeUrl(
              user_pivot.user.filestorage.path
            );
          });
        });
        this.evolChartsArray = new Array(this.teamsProjects.length).fill(null);
        this.capChartsArray = new Array(this.teamsProjects.length).fill(null);
        this.teamChartsArray = new Array(this.teamsProjects.length).fill(null);
      });
  }

  /* funzione per passare i dati alla modale */
  storeData(selectedData: any, search_id: any, projectData: any) {
    let utility = this.utilityService;

    this.profileService.getOtherUserProfile(search_id).subscribe(res => {
      this.selected_user_profile = res.result[0];

      this.aspiration = this.selected_user_profile.my_aspiration;

      this.selected_user_profile.hobbies.forEach(function (hobby: any) {
        hobby.filestorage.path = utility.getSanitizeUrl(hobby.filestorage.path);

        hobby.children.forEach(function (child: any) {
          child.filestorage.path = utility.getSanitizeUrl(
            child.filestorage.path
          );
        });
      });

      this.selected_user_profile.hobbyunion.forEach(function (union: any) {
        union.filestorage.path = utility.getSanitizeUrl(union.filestorage.path);

        union.children.forEach(function (union_child: any) {
          union_child.filestorage.path = utility.getSanitizeUrl(
            union_child.filestorage.path
          );
        });
      });

      this.selectedProfileData = selectedData;
      // this.selectedProjectRole = projectData.assignmentrole.alias;
    });
  }

  public getSanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  open_Profile(event: Event) {
    const dialogRef = this.dialog.open(ModaleProfiloComponent, {
      // width: '450px',
    });
    event.stopPropagation();
  }

  getElement(element: any) {
    this.id = element;
    this.myModalAlternative.show(); /* Per aprire la modale al click dell'immagine */
    this.getProfileUser();
  }

  getProfileUser() {
    this.profileService.profileUser(this.id).subscribe(res => {
      this.profile = res.result;
    });
  }

  slugify(text: string) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') // Sostituisci spazi con trattini
      .replace(/[^\w\-]+/g, '') // Rimuovi tutti i caratteri non alfanumerici eccetto i trattini
      .replace(/\-\-+/g, '-'); // Sostituisci trattini multipli con un singolo trattino
  }

  goToScrum(project: any) {
    let navigationExtras = {
      relativeTo: this.route,
      state: project
    };
    let sprint;
    if (project.end_sprint_number_) {
      sprint = project.end_sprint_number_;
    } else {
      sprint = 0;
    }
    this.router.navigate(
      [this.slugify(project.alias.toLowerCase()), 'sprints', sprint.toString()],
      navigationExtras
    );
  }

  stopEventPropagation(event: Event) {
    event.stopPropagation();
  }

  setDate(
    project_id: number,
    number: number,
    toggle: boolean,
    other_number: any,
    index: number
  ) {
    if (toggle) {
      if (
        !this.endSprintNumber ||
        (this.endSprintNumber && this.endSprintNumber >= number)
      )
        this.startSprintNumber = number;
      this.endSprintNumber = other_number;
    } else {
      if (
        !this.startSprintNumber ||
        (this.startSprintNumber && this.startSprintNumber <= number)
      )
        this.endSprintNumber = number;
      this.startSprintNumber = other_number;
    }

    if (this.startSprintNumber && this.endSprintNumber) {
      // effettua la chiamata per i dati dello sprint
      this.getDataSprint(
        project_id,
        this.startSprintNumber,
        this.endSprintNumber,
        index
      );
    }
  }

  getDataSprint(
    projectId: number,
    startSprint: any,
    endSprint: any,
    index: number
  ) {
    this.scrumService
      .getDataSprint(projectId, startSprint, endSprint)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async res => {
          this.teamsProjects.find(
            (project: any) => project.id == projectId
          ).statistical = res;
          await this.getTeamassassmentData(projectId, startSprint, endSprint);
          this.createCharts(index);
        }
      });
  }

  async getTeamassassmentData(id: any, start?: any, end?: any): Promise<void> {
    const r = await firstValueFrom(
      this.projectService.getTeamassassmentData(id, start, end)
    );

    // Sostituisce l'array invece di fare il `push` all'interno di labels
    this.labels = [...r.labels];

    this.media = r.dataArray;

    this.configTeamChartData = {
      labels: r.labels,
      datasets: [
        this.createDataset('Clarity', r.dataArray[0].data, '255, 0, 0'),
        this.createDataset('Confidence', r.dataArray[4].data, '255, 165, 0'),
        this.createDataset('Efficency', r.dataArray[5].data, '0, 128, 0'),
        this.createDataset('Energy', r.dataArray[1].data, '0, 0, 255'),
        this.createDataset(
          'Psycological Safety',
          r.dataArray[2].data,
          '102, 102, 102'
        ),
        this.createDataset(
          'Work-life Balance',
          r.dataArray[3].data,
          '128, 0, 128'
        )
      ]
    };

    this.showChart = true;
  }

  createDataset(label: string, data: any, color: any) {
    return {
      label: label,
      data: data,
      backgroundColor: `rgba(${color}, 0.4)`,
      borderColor: `rgba(${color}, 0.4)`,
      pointBackgroundColor: `rgba(${color}, 0.4)`,
      pointBorderColor: `rgba(${color}, 0.4)`,
      cubicInterpolationMode: 'monotone',
      borderWidth: 2,
      pointRadius: 2,
      hoverBorderWidth: 4,
      pointHoverRadius: 4,
      hoverBackgroundColor: `rgb(${color})`,
      hoverBorderColor: `rgb(${color})`,
      highlighted: false,
      hidden: false,
      spanGaps: true
    };
  }

  /**
   * Questa funzione serve per distruggere i grafici nel caso siano gia esistenti
   * @param index indice del grafico
   */
  destroyExistingCharts(index: number) {
    if (this.evolChartsArray[index]) {
      this.evolChartsArray[index].chart.destroy();
      this.evolChartsArray[index] = null;
    }
    if (this.capChartsArray[index]) {
      this.capChartsArray[index].chart.destroy();
      this.capChartsArray[index] = null;
    }
    if (this.teamChartsArray[index]) {
      this.teamChartsArray[index].chart.destroy();
      this.teamChartsArray[index] = null;
    }
  }

  /**
   * funzione che serve per estrarre tutti i dati utili per creare i vari grafici
   * @param project progetto di cui vogliamo estrarre i dati
   * @returns tutti i dati di quel progetto
   */
  getChartData(project: any) {
    return {
      velocityTeamData: project.statistical.velocity_graph.velocity_team.map(
        (point: any) => point.value
      ),
      velocityInternoData:
        project.statistical.velocity_graph.velocity_interno.map(
          (point: any) => point.value
        ),
      velocityClienteData:
        project.statistical.velocity_graph.velocity_cliente.map(
          (point: any) => point.value
        ),
      velocityLabels: project.statistical.velocity_graph.velocity_team.map(
        (point: any) => point.sprint_number
      ),
      capacityLabels: project.statistical.capacity_graph.map(
        (point: any) => point.user
      ),
      capacityData: project.statistical.capacity_graph
    };
  }

  // creazione del grafico velocity
  createVelocityChart(index: number, project: any, canvas: HTMLCanvasElement) {
    const {
      velocityTeamData,
      velocityInternoData,
      velocityClienteData,
      velocityLabels
    } = this.getChartData(project);

    const configEvolChart: ChartConfiguration<'line'> = {
      type: 'line',
      data: {
        labels: velocityLabels,
        datasets: [
          {
            label: 'Team',
            backgroundColor: this.transparentize(CHART_COLORS.yellow, 0.7),
            borderColor: CHART_COLORS.yellow,
            fill: true,
            data: velocityTeamData
          },
          {
            label: 'Interno',
            backgroundColor: this.transparentize(CHART_COLORS.green, 0.7),
            borderColor: CHART_COLORS.green,
            fill: true,
            data: velocityInternoData
          },
          {
            label: 'Cliente',
            backgroundColor: this.transparentize(CHART_COLORS.blue, 0.7),
            borderColor: CHART_COLORS.blue,
            fill: true,
            data: velocityClienteData
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: []
          }
        },
        scales: {
          x: {
            bounds: 'ticks',
            title: { display: true, text: 'Sprint' },
            ticks: { source: 'labels' },
            grid: { display: false }
          },
          y: {
            title: { display: true, text: 'Velocity' },
            beginAtZero: true,
            suggestedMax: 0.4
          }
        }
      }
    };

    this.typologies.map((typo: any) => {
      let constant = {
        drawTime: 'afterDatasetsDraw',
        type: 'line',
        scaleID: 'y',
        value: typo.ideal_velocity,
        borderColor: this.transparentize(typo.color_code, 0.6),
        borderWidth: 2,
        label: {
          drawTime: 'afterDatasetsDraw',
          display: false,
          backgroundColor: this.transparentize(typo.color_code, 0.9),
          font: { size: 12 },
          content: `${typo.alias} (${typo.ideal_velocity})`,
          position: 'end'
        },
        enter({ element }: any, event: any) {
          element.label.options.display = true;
          return true;
        },
        leave({ element }: any, event: any) {
          element.label.options.display = false;
          return true;
        }
      };

      // Inizializza correttamente l'array annotations
      configEvolChart.options!.plugins = configEvolChart.options!.plugins || {};
      configEvolChart.options!.plugins.annotation =
        configEvolChart.options!.plugins.annotation || {};

      // Usa un cast esplicito per evitare il tipo errato
      const annotations =
        (configEvolChart.options!.plugins.annotation
          .annotations as Array<any>) || [];

      // Aggiungi l'elemento a annotations
      annotations.push(constant);

      // Assicurati che annotations venga assegnato di nuovo a configEvolChart.options.plugins.annotation.annotations
      configEvolChart.options!.plugins.annotation.annotations = annotations;
    });

    this.evolChartsArray[index] = {
      id: project.id,
      chart: new Chart(canvas, configEvolChart)
    };
  }

  // Creazione del grafico di capacity
  createCapacityChart(index: number, project: any, canvas: HTMLCanvasElement) {
    const { capacityLabels, capacityData } = this.getChartData(project);

    const configCapChart: ChartConfiguration<'pie'> = {
      type: 'pie',
      data: {
        labels: capacityLabels,
        datasets: [
          {
            label: 'Ore',
            backgroundColor: Object.values(PIE_CHART_COLORS),
            borderColor: '#f4f3ef',
            data: capacityData
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right' // Aggiungi questa riga per spostare la legenda a destra
          },
          title: {
            text: 'Andamento Sprint',
            display: true,
            font: { size: 16 }
          },
          annotation: { annotations: [] }
        }
      }
    };

    this.capChartsArray[index] = {
      id: project.id,
      chart: new Chart(canvas, configCapChart)
    };
  }

  // Creazione del grafico per team assessment
  createTeamAssessmentChart(index: number) {
    if (this.teamChartsArray[index]) {
      this.teamChartsArray[index].chart.destroy();
      this.teamChartsArray[index] = null;
    }

    const teamCharts = document.getElementById(
      'teamChart' + index
    ) as HTMLCanvasElement;

    if (!teamCharts) return;

    // Configurazione del grafico Team Assessment
    const configTeamChart: ChartConfiguration = {
      type: 'line',
      data: this.configTeamChartData,
      options: {
        aspectRatio: 1,
        responsive: true,
        maintainAspectRatio: false,
        devicePixelRatio: 4,
        plugins: {
          legend: {
            position: 'bottom',
            onClick: (event, legendItem) => {
              this.handleLegendClick(event, legendItem, configTeamChart);
            }
          },
          tooltip: {
            callbacks: {
              title: context => `Sprint ${context[0].label}`
            }
          }
        },
        scales: {
          x: {
            title: { text: 'Sprint', display: true, font: { size: 10 } },
            ticks: {
              callback: (value, index) => {
                if (this.labels.length > 15) {
                  return index % 5 === 0 ? this.labels[index - 1] : '';
                }
                return this.labels[index];
              },
              autoSkip: false
            }
          }
        },
        hover: {
          mode: 'dataset',
          intersect: false
        }
      }
    };

    // Crea il grafico
    this.teamChartsArray[index] = {
      id: this.teamsProjects[index].id,
      chart: new Chart(teamCharts, configTeamChart)
    };
  }

  handleLegendClick(event: any, legendItem: any, configTeamChart: any) {
    const datasetIndex = legendItem.datasetIndex;
    const chart = event.chart;
    const dataset = configTeamChart.data.datasets[datasetIndex];
    dataset.highlighted = !dataset.highlighted;

    if (!this.isDesktop) {
      this.updateDatasetStyles(configTeamChart.data.datasets);
      chart.update();
    } else {
      dataset.hidden = !dataset.hidden;
      chart.update();
    }
  }

  updateDatasetStyles(datasets: any[]) {
    datasets.forEach(dataset => {
      if (dataset.highlighted) {
        dataset.borderWidth = 4;
        dataset.pointRadius = 4;
        dataset.pointBackgroundColor = dataset.pointBackgroundColor.replace(
          /rgba\((\d+, \d+, \d+), 0\.4\)/,
          'rgba($1, 1)'
        );
      } else {
        dataset.borderWidth = 2;
        dataset.pointRadius = 2;
        dataset.pointBackgroundColor = dataset.pointBackgroundColor.replace(
          /rgba\((\d+, \d+, \d+), 1\)/,
          'rgba($1, 0.4)'
        );
      }
    });
  }

  createCharts(index: number) {
    this.destroyExistingCharts(index);

    const evolCanvas = document.getElementById(
      'evolChart' + index
    ) as HTMLCanvasElement;
    const capCanvas = document.getElementById(
      'capChart' + index
    ) as HTMLCanvasElement;

    const project = this.teamsProjects[index];

    if (project) {
      if (project.statistical?.velocity_graph && !this.evolChartsArray[index]) {
        this.createVelocityChart(index, project, evolCanvas);
      }

      if (project.statistical?.capacity_graph && !this.capChartsArray[index]) {
        this.createCapacityChart(index, project, capCanvas);
      }

      this.createTeamAssessmentChart(index);
    }
  }

  /* ANIMATION GIF */
  handleAnimation(anim: any) {
    this.anim = anim;
  }

  transparentize(value: any, opacity: any) {
    var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    return colorLib(value).alpha(alpha).rgbString();
  }

  toggleFlip(card: any, projectId: any, i: number) {
    card.classList.toggle('flipped');
    this.getDataSprint(
      projectId,
      this.startSprintNumber,
      this.endSprintNumber,
      i
    );
  }

  onSearchTeam(event: string) {
    this.searchTeamSubject.next(event);
  }

  getProjectSelect(search: string = '') {
    this.teamsService
      .getProjectsSelect(search)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: res => {
          this.teamProjectsSelect = res.result;
        }
      });
  }

  onSelectTamsProject(event: number[]) {
    this.selectedTeamProjects = event;
    this.getTeams('', this.selectedTeamProjects);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
